export const testimonials = [
  {
    name: 'Sarah & Markus',
    text: 'Die Fotobox war der absolute Hit auf unserer Feier! Die Gäste hatten den ganzen Abend Spaß damit und die Qualität der Fotos ist erstklassig. Der Service war von Anfang bis Ende professionell und zuverlässig.',
    rating: 5
  },
  {
    name: 'Julia & Tom',
    text: 'Super Service von Anfang bis Ende. Das Team hat ein wunderschönes Layout für uns designt und der Aufbau lief problemlos. Die digitale Galerie war am nächsten Tag schon verfügbar. Einfach perfekt!',
    rating: 5
  },
  {
    name: 'Lisa & Jan',
    text: 'Die Qualität der Fotos und Ausdrucke war überragend. Unsere Gäste haben die Fotobox den ganzen Abend genutzt und wir haben nun tolle Erinnerungen für die Ewigkeit.',
    rating: 5
  },
  {
    name: 'Mia & Alexander',
    text: 'Sehr professioneller Service! Die Fotobox funktionierte einwandfrei und die Bedienung war super einfach. Die Requisiten waren vielfältig und haben für viele Lacher gesorgt. Absolut empfehlenswert!',
    rating: 5
  },
  {
    name: 'Sandra & Michael',
    text: 'Eine Fotobox von mietfotobox zu buchen war die beste Entscheidung. Der Support war freundlich und hat alle unsere Fragen sofort beantwortet. Die Fotos sind von ausgezeichneter Qualität und werden eine schöne Erinnerung bleiben.',
    rating: 5
  },
  {
    name: 'Nicole & Philipp',
    text: 'Wir sind begeistert von der Qualität und dem Service. Die Gäste waren von der Fotobox nicht mehr wegzubekommen! Das Team war äußerst flexibel und hat alle unsere Wünsche erfüllt. Vielen Dank!',
    rating: 5
  },
  {
    name: 'Emma & David',
    text: 'Von der Anfrage bis zum Abbau - alles lief super reibungslos. Die Fotobox war ein echtes Highlight und das Gästebuch mit den Fotos ist ein wunderschönes Andenken. Würden jederzeit wieder buchen!',
    rating: 5
  },
  {
    name: 'Sophia & Felix',
    text: 'Die individuelle Gestaltung der Fotostreifen hat uns besonders gut gefallen. Die Bilder sind gestochen scharf und die Bedienung ist kinderleicht. Der Service war stets freundlich und zuverlässig.',
    rating: 5
  },
  {
    name: 'Laura & Max',
    text: 'Eine absolute Empfehlung! Die Kommunikation war von Anfang an super und das Preis-Leistungs-Verhältnis stimmt absolut. Die Fotobox hat für so viele unvergessliche Momente gesorgt.',
    rating: 5
  },
  {
    name: 'Hannah & Jonas',
    text: 'Einfach nur großartig! Die Fotobox war der Renner bei unseren Gästen. Die Fotos sehen fantastisch aus und wurden sofort ausgedruckt. Der Service war top und die Bedienung kinderleicht.',
    rating: 5
  },
  {
    name: 'Christina & Tobias',
    text: 'Das Team von mietfotobox hat einen tollen Job gemacht. Pünktlich, professionell und mit einem Auge fürs Detail. Die Fotobox lief den ganzen Abend ohne Probleme und die Fotos sind wunderschön geworden.',
    rating: 5
  },
  {
    name: 'Lena & Paul',
    text: 'Die Fotobox war definitiv ein Highlight! Unkomplizierte Abwicklung, tolle Betreuung und ein super Preis-Leistungs-Verhältnis. Wir und unsere Gäste sind begeistert von den Ergebnissen!',
    rating: 5
  }
]

// Funktion, die zufällig 3 Testimonials auswählt
export function getRandomTestimonials(count = 3) {
  // Kopiere das Array, um es nicht zu verändern
  const shuffled = [...testimonials]
  
  // Fisher-Yates Shuffle Algorithmus
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
  }
  
  // Gib die ersten 'count' Elemente zurück
  return shuffled.slice(0, count)
}